define('constants/receptionistMessageConstants',[], function() {
    return {
        status: {
            new: {
                id: 1,
                name: "New",
                status: "new"
            },
            reviewed: {
                id: 2,
                name: "Reviewed",
                status: "reviewed",
            }
        },
        junkStatus: {
            abandoned: {
                id: 0,
                name: "Abandoned",
                status: "abandoned"
            },
            hangup: {
                id: 1,
                name: "Hangup",
                status: "hangup",
            },
            spam: {
                id: 2,
                name: "Spam",
                status: "spam",
            },
            externalWebsite: {
                id: 3,
                name: "External Website",
                status: "externalWebsite",
            }
        },
        interactionType: {
            call: {
                id: 0,
                name: "Call",
                status: "call",
            },
            chat: {
                id: 1,
                name: "Chat",
                status: "chat",
            },
            email: {
                id: 2,
                name: "Email",
                status: "email",
            }
        }
    };
});
